import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Container} from './styles';
import Books from '../../assets/emojis/ajuda/books.png';
import Contrato from '../../assets/emojis/ajuda/contrato.png';
import Money from '../../assets/emojis/ajuda/money.png';
import Keyboard from '../../assets/emojis/ajuda/keyboard.png';
import Open_book from '../../assets/emojis/ajuda/open_book.png';


export default class Ajuda extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carregou: true,
        }
    }

    render() {
        return(
            <Container>
            
            {this.state.carregou ?
            <div className="div-pai">
                <div className="div-rota">  

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/'}>
                    <span
                        className="rotas" >
                        Início
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/ajuda'}>
                    <span>
                        Ajuda
                    </span>
                </Link>

                </div>

                <img alt="" className="emoji" src={Books} />

                <h1>Ajuda</h1>

                <h5>Obtenha informações sobre seu contrato e outras orientações.</h5>

                <div className="pages">
                    
                    {/* <div className="page" onClick={() => this.props.history.push('/ajuda/meucontrato')}>
                        <img alt="" className="emoji" src={Contrato} />
                        <h4>Meu contrato</h4>
                        <h5>Obtenha informações sobre seu contrato <p>como taxas e condições ofertadas.</p></h5>
                        
                        <div className="botao">
                            <button className="salvar">
                                Ver mais
                            </button>
                        </div>
                    </div> */}

                    <div className="page" onClick={() => {}}>
                        <img alt="" className="emoji" src={Money} />
                        <h4>Gestor de Negócios</h4>
                        <h5>Baixe em seu celular, ou computador <p>os aplicativos para receber os pedidos.</p></h5>
                        
                        <div className="botao">
                            <button className="salvar">
                                <a className='salvar1' href='http://onelink.to/pcgcar' target ="_blank">
                                    Baixar
                                </a>
                            </button>
                        </div>
                    </div>


                    <div className="page" onClick={() => {}}>
                        <img alt="" className="emoji" src={Keyboard} />
                        <h4>Central de Atendimento</h4>
                        <h5>Fale com o nosso time de atendimento <p>via Whatsapp.</p></h5>
                    
                        <div className="botao">
                            <button className="salvar">
                                <a className="salvar1" href='https://wa.me/5518981494012?text=Ol%C3%A1!%20Preciso%20de%20ajuda!' target="_blank">
                                    Ver mais
                                </a>
                            </button>
                        </div>
                    </div>

                    <div className="page" onClick={() => {}}>
                        <img alt="" className="emoji" src={Open_book} />
                        <h4>Central de Ajuda</h4>
                        <h5>Leia nosso material de apoio para tirar <p>duvidas sobre o funcionamento da plataforma.</p></h5>
                        
                        <div className="botao">
                            <button className="salvar">
                                <a className='salvar1' href='https://appedidos.zendesk.com/' target ="_blank">
                                    Ver mais
                                </a>
                            </button>
                        </div>
                    </div>
                </div>

            </div>

            :
            null}
            </Container>
        )
    }
}